/**
 * Emergency cache clear utility
 * Use this when users report login issues or glitchy behavior
 */

export const emergencyCacheClear = async (): Promise<boolean> => {
  try {
    // 1. Clear ALL localStorage
    localStorage.clear();
    
    // 2. Clear ALL sessionStorage  
    sessionStorage.clear();
    
    // 3. Clear ALL cookies for this domain
    document.cookie.split(';').forEach(cookie => {
      const [name] = cookie.trim().split('=');
      const cookieBase = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT;`;
      document.cookie = `${cookieBase} path=/;`;
      document.cookie = `${cookieBase} path=/; domain=${window.location.hostname};`;
      document.cookie = `${cookieBase} path=/; domain=.${window.location.hostname};`;
    });
    
    // 4. Clear ALL application caches
    if ('caches' in window) {
      const cacheNames = await caches.keys();
      await Promise.all(cacheNames.map(cacheName => caches.delete(cacheName)));
    }
    
    // 5. Clear ALL IndexedDB databases
    if (typeof indexedDB !== 'undefined') {
      const databases = [
        'firebaseLocalStorage',
        'firebaseLocalStorageDb', 
        'firebase-installations-database',
        'firebase-heartbeat-database',
        'firebase-messaging-database'
      ];
      
      await Promise.all(databases.map(async (dbName) => {
        try {
          const deleteRequest = indexedDB.deleteDatabase(dbName);
          await new Promise((resolve) => {
            deleteRequest.onsuccess = () => resolve(true);
            deleteRequest.onerror = () => resolve(true); // Continue even if error
            deleteRequest.onblocked = () => {
              setTimeout(resolve, 1000); // Force continue after timeout
            };
          });
        } catch (err) {
          // Silently handle individual database errors
        }
      }));
    }
    
    return true;
    
  } catch (error) {
    return false;
  }
};

// Removed dev-only window hook and hotkey listener per product decision
